import { Component, OnInit } from '@angular/core';
import { FormControlsBase, providerFormControlsBase } from '../form-controls.base';
import { ControlContainer } from '@angular/forms';

@Component({
  selector: 'bvl-form-textarea',
  templateUrl: './form-textarea.component.html',
  providers: [providerFormControlsBase(BvlFormTextareaComponent)]
})
export class BvlFormTextareaComponent extends FormControlsBase implements OnInit {

  constructor(controlContainer: ControlContainer) {
    super(controlContainer);
  }

  ngOnInit(): void { }

}
